import React from 'react'
import moment from "moment/moment"
import {Badge} from 'reactstrap'
import LoadingButton from "../LoadingButton";
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'

import downloadFileMutation from '../../../queries/server/mutations/download_file'
import removeUserExpenseMutation from '../../../queries/server/mutations/remove_user_expense'

const {format} = Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
})

const UserExpenseListItem = ({
                                 id,
                                 user_id,
                                 project,
                                 user,
                                 expense_at,
                                 destination,
                                 description,
                                 expense_type_obj,
                                 net,
                                 vat,
                                 gross,
                                 created_at,
                                 paid_at,
                                 file_path,
                                 onEdit,
                                 onDownload,
                                 onDelete
                             }) => {
    return (
        <div className="d-flex flex-row justify-content-between align-items-center p-2 border-bottom">
            <div className="d-flex flex-column align-items-start justify-content-center">
                <h7>{format(gross)} <Badge
                    color={paid_at ? 'success' : 'warning'}>{paid_at ? 'Paid' : 'Outstanding'}</Badge>
                </h7>
                {project && project.hasOwnProperty('project_id') && <small className="text-muted">Project: {project.project_id} - {project.name}</small>}
                <small className="text-muted">User: {user.full_name}</small>
                <small className="text-muted">Expense Type: {expense_type_obj.description}</small>
                <small className="text-muted">Expense Date: {moment(expense_at).format('DD/MM/YYYY')}</small>
                <small className="text-muted">Destination: {destination}</small>
                <small className="text-muted">Description: {description}</small>

            </div>

            <div className="d-flex flex-row">
                <LoadingButton
                    className="square-btn mr-2"
                    icon="edit"
                    loading={false}
                    size="sm"
                    color="warning"
                    forceDisabled={false}
                    onClick={() => {
                        if (onEdit) onEdit(id)
                    }}
                />

                {file_path && <Mutation mutation={downloadFileMutation}>
                    {(downloadFileMutationFunc, {loading}) => (<LoadingButton
                        className="square-btn mr-2"
                        size="sm"
                        icon="file-download"
                        loading={loading}
                        color="primary"
                        forceDisabled={false}
                        onClick={() => {
                            downloadFileMutationFunc({variables: {url: file_path}})
                                .then(({data}) => {
                                    const {downloadFile} = data
                                    //window.open(downloadFile)
                                    if (onDownload) onDownload(downloadFile)
                                })


                        }}
                    />)}
                </Mutation>
                }


                <Mutation mutation={removeUserExpenseMutation}>
                    {(removeUserExpenseMutationFunc, {loading}) => (
                        <LoadingButton
                            className="square-btn"
                            size="sm"
                            icon="trash-alt"
                            loading={loading}
                            color="danger"
                            forceDisabled={false}
                            onClick={() => {
                                removeUserExpenseMutationFunc({
                                    variables: {
                                        id,
                                    }
                                })
                                    .then(({data}) => {
                                        if (onDelete) onDelete(id)
                                    })
                            }}
                        />
                    )}
                </Mutation>

            </div>

        </div>
    )
}

UserExpenseListItem.propTypes = {
    onEdit: PropTypes.func,
    onDownload: PropTypes.func,
    onDelete: PropTypes.func,
    downloading: PropTypes.bool,

}

export default UserExpenseListItem

